/**
 * 出口检测报告管理
 */
import React from 'react';
import { Input, Button, Row, Col, Icon, Tooltip, DatePicker } from 'antd';
import PageLayout from '../../ui/PageLayout';
//加载中遮罩
import Loading from '../../ui/Loading';
//消息提示
import messager from '../../ui/messager';
import http from '../../../axios/http';
//import { global_data } from '../../ui/auth'
//修改页
import ExportCheckReportEdit from './ExportCheckReportEdit';
//申请表打印
// import ReportPrint from './ReportPrint';
// import NoBorderReportPrint from './NoBorderReportPrint';
// import { global_data } from '../../ui/auth'



class ExportCheckReportIndex extends React.Component {
    columns = [{
        title: '创建时间',
        dataIndex: 'createTime',
        width: '10%',
    }
    ,{
        title: '最后编辑时间',
        dataIndex: 'updateTime',
        width: '10%',
    }
    ,{
        title: '委托人',
        dataIndex: 'principal',
        width: '14%',
    }
    ,{
        title: '车牌号',
        dataIndex: 'plateNo',
        width: '6%',
    }
    ,{
        title: '车架号',
        dataIndex: 'vin',
        width: '12%',
    }
    ,{
        title: '品牌',
        dataIndex: 'brand',
        width: '6%',
    }
    ,{
        title: '型号',
        dataIndex: 'model',
        width: '6%',
    }
    ,{
        title: '发动机/电机号',
        dataIndex: 'engineNo',
        width: '8%',
    }
    ,{
        title: '出厂日期',
        dataIndex: 'produceDate',
        width: '8%',
    }
    ,{
        title: '操作',
        dataIndex: 'id',
        width: '15%',
        render: (text, record, index) => (
            <div>
                {/* {global_data.authCode.includes("EXPORT_CHECK_REPORT_UPDATE")? */}
                <Tooltip title="修改信息">
                    <Icon type="edit" theme="filled" className="table-operate-icon" onClick={this.update.bind(this, record.id)} />
                </Tooltip>
                {/* :""}  */}
                {/* {global_data.authCode.includes("EXPORT_CHECK_REPORT_DELETE")? */}
                <Tooltip title="删除">
                    <Icon type="delete" theme="filled" className="table-operate-icon" onClick={this.delete.bind(this, record.id)} />
                </Tooltip>
                {/* :""} */}
                {/* {global_data.authCode.includes("EXPORT_CHECK_REPORT_COPY")? */}
                <Tooltip title="复制">
                    <Icon type="copy" theme="filled" className="table-operate-icon" onClick={this.copy.bind(this, record.id)} />
                </Tooltip>
                {/* :""} */}
                {/* {global_data.authCode.includes("EXPORT_CHECK_REPORT_DOWNLOAD")? */}
                <Tooltip title="下载完整报告">
                    <Icon type="download" className="table-operate-icon" onClick={this.downloadWhole.bind(this, record)} />
                </Tooltip>
                {/* :""} */}
                 {/* {global_data.authCode.includes("EXPORT_CHECK_REPORT_PRINT")? */}
                <Tooltip title="下载空白报告">
                    <Icon type="download" className="table-operate-icon" onClick={this.downloadBlank.bind(this, record)} />
                </Tooltip>
                {/* :""} */}
                <Tooltip title="下载报告内容">
                    <Icon type="download" className="table-operate-icon" onClick={this.downloadContent.bind(this, record)} />
                </Tooltip>
                 {/* {global_data.authCode.includes("EXPORT_CHECK_REPORT_PRINTCONTENT")? */}
                {/* <Tooltip title="打印套打内容(无边框报告)">
                    <Icon type="printer" theme="filled" className="table-operate-icon" onClick={this.printNoBorderReport.bind(this, record.id)} />
                </Tooltip> */}
                {/* :""} */}
            </div>
        ),
    }];

    state = {
        visible: false,
        loadData: '',
        editData: {},   //编辑页面使用的数据
        detailData: {},  //详情页面使用的数据
        queryData: {}, //查询数据
        loadingVisible: false,
        printData: {}, //网页版打印窗口数据
        printVisible: false, //网页版打印窗口可见标记
        NoBorderReportPrintVisible:false //网页版无边框打印窗口可见标记
    };

    componentDidMount() {
    }

    format = (m) => {
        return m < 10 ? '0' + m : m
    }
    add = () => {
        let date = new Date();
        let createDate = date.getFullYear() + '-' + this.format(date.getMonth() + 1) + '-' + this.format(date.getDate());
        let expDate = date.getFullYear() + '-' + this.format(date.getMonth() + 5) + '-' + this.format(date.getDate()-1);
        let editData={
            createTime:createDate,
            expirationDate:expDate
        }
        this.setState({
            editData: editData,
            visible: true
        });
        this.initFile(editData);
        this.initEdit(editData);
    }


    update = (info, e) => {
        this.setState({ loadingVisible: true });
        http.get({
            url: '/exportCheckReport/get',
            data: { id: info },
            success: (res) => {
                this.setState({ 
                    editData: res
                });
                this.setState({ editData: res, visible: true, loadingVisible: false  });
                this.initFile(res);
                this.initEdit(res);
            },
            error: () => {
                this.setState({ loadingVisible: false });
            }
        });
    }

    copy = (id) => {
        this.setState({ loadingVisible: true });
        http.post({
            url: "/exportCheckReport/copy",
            data: { "id": id },
            success: (res) => {
                this.state.loadData();
                this.setState({ loadingVisible: false });
                messager.notify("复制成功！");
            },
            error: (res) => {
            }
        });
    }
    //下载完整报告
    downloadWhole = (info) => {
        this.setState({ loadingVisible: true });
        let url = "/exportCheckReport/download/whole";
        let preStr=info.type==="1"?"乘用车":"商用车"
        let fileName = preStr+"出口检测报告.docx";
        http.download({
            url: url,
            data: { "id": info.id },
            fileName: fileName,
            success: (res) => {
                messager.notify("下载成功！");
                this.setState({ loadingVisible: false });
            },
            error: (res) => {
                this.setState({ loadingVisible: false });
            }
        });
    }   

    //下载空白报告
    downloadBlank = (info) => {
        this.setState({ loadingVisible: true });
        let url = "/exportCheckReport/download/blank";
        let preStr=info.type==="1"?"乘用车":"商用车"
        let fileName = preStr+"空白报告.docx";
        http.download({
            url: url,
            data: { "id": info.id },
            fileName: fileName,
            success: (res) => {
                messager.notify("下载成功！");
                this.setState({ loadingVisible: false });
            },
            error: (res) => {
                this.setState({ loadingVisible: false });
            }
        });
    }
    
    
    //下载报告内容
    downloadContent= (info) => {
        this.setState({ loadingVisible: true });
        let url = "/exportCheckReport/download/content";
        let preStr=info.type==="1"?"乘用车":"商用车"
        let fileName = preStr+"报告内容.docx";
        http.download({
            url: url,
            data: { "id": info.id },
            fileName: fileName,
            success: (res) => {
                messager.notify("下载成功！");
                this.setState({ loadingVisible: false });
            },
            error: (res) => {
                this.setState({ loadingVisible: false });
            }
        });
    }


    // printNoBorderReport = (info, e) => {
    //     http.post({
    //         url: '/exportCheckReport/print',
    //         data: { id: info },
    //         success: (res) => {
    //             this.setState({ printData: res, NoBorderReportPrintVisible: true });
    //         }
    //     });
    // }

    hiddenModalPrint = () => {
        this.setState({ printVisible: false });
    }

    // hiddenModalNoBorderPrint = () => {
    //     this.setState({ NoBorderReportPrintVisible: false });
    // }


    monthDiff = (date1, date2) => {
        // 拆分年月du日zhi
        date1 = date1.split('-');
        // 得到月数dao
        date1 = parseInt(date1[0]) * 12 + parseInt(date1[1]);
        // 拆分年月日
        date2 = date2.split('-');
        // 得到月数
        date2 = parseInt(date2[0]) * 12 + parseInt(date2[1]);
        var m = Math.abs(date1 - date2);
        return m;
    }
    transferData = (res, field) => {
        let buyer = res[field];
        for (let key in buyer) {
            res[field + "." + key] = buyer[key];
        }
        delete res[field];
    }
    delete = (info, e) => {
        messager.confirm("是否删除该报告？", () => {
            http.post({
                url: '/exportCheckReport/delete',
                data: { id: info },
                success: (res) => {
                    this.state.loadData();
                    messager.notify("删除成功！");
                }
            });
        });
    }
    detail = (info, e) => {
        http.post({
            url: '/application/findApplicationDetail',
            data: { applicationId: info },
            success: (res) => {
                this.transferData(res, "buyer");
                this.transferData(res, "seller");
                this.transferData(res, "vehicle");
                //this.transferData(res, "ticket");
                res["vehicle.isImported"] = res["vehicle.isImported"] === 1 ? '是' : '否';
                res["agent"] = res["agent"] === 1 ? '是' : '否';
                this.setState({ detailData: res });
                this.showModalDetal();
            }
        });
    }

    showModal = () => {
        this.setState({ visible: true });
    }
    hiddenModal = () => {
        this.setState({ visible: false, editData: {} });
    }
    showModalDetal = () => {
        this.setState({ detailVisible: true });
    }
    hiddenModalDetail = () => {
        this.setState({ detailVisible: false });
    }

    reloadDataFunc = () => {
        this.state.loadData();
    }

    inputSearch = (field, value) => {
        let queryData = this.state.queryData;
        queryData[field] = value
        this.state.loadData(queryData);
        this.setState({ queryData: queryData });
    }

    rangePickerChange = (dates, dateStrings) => {
        let queryData = this.state.queryData;
        queryData.startDate = dateStrings[0];
        queryData.endDate = dateStrings[1];
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    selectChange = (value) => {
        let queryData = this.state.queryData;
        queryData.invoiceState = value;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }


    render() {
        return (
            <div style={{ width: '100%', height: '100%' }}>
                <PageLayout
                    condition={(
                        <Row>
                            <Col span={20}>
                                <Input.Search
                                    placeholder="车牌号/车架号"
                                    onSearch={this.inputSearch.bind(this, "keyWords")}
                                    enterButton
                                    style={{ width: '250px', marginRight: '30px' }}
                                />
                                <Input.Search
                                    placeholder="委托人"
                                    onSearch={this.inputSearch.bind(this, "principal")}
                                    enterButton
                                    style={{ width: '250px', marginRight: '30px' }}
                                />
                                <DatePicker.RangePicker onChange={this.rangePickerChange} style={{ marginRight: '10px' }} />
                            </Col>
                            <Col span={4} style={{ textAlign: "right" }}>
                                {/* {global_data.authCode.includes("EXPORT_CHECK_REPORT_ADD")? */}
                                <Button type="primary" onClick={this.add} style={{ marginRight: '10px' }}>新增</Button>
                                {/* :""}  */}
                            </Col>
                        </Row>
                    )}
                    rowKey="id"
                    url="/exportCheckReport/page"
                    requestType="get"
                    columns={this.columns}
                    loadData={(func) => { this.setState({ loadData: func }) }}
                />
                <ExportCheckReportEdit
                    visible={this.state.visible}
                    onCancel={this.hiddenModal.bind(this)}
                    editData={this.state.editData}
                    successCallback={this.reloadDataFunc}
                    // queryData={this.state.queryData}
                    initFunc={(func) => { this.initEdit = func }}
                    initFile={(func) => { this.initFile = func }}
                />
                {/* <ReportPrint
                    visible={this.state.printVisible}
                    onCancel={this.hiddenModalPrint.bind(this)}
                    printData={this.state.printData}
                /> */}
                {/* <NoBorderReportPrint
                    visible={this.state.NoBorderReportPrintVisible}
                    onCancel={this.hiddenModalNoBorderPrint.bind(this)}
                    printData={this.state.printData}
                /> */}
                <Loading
                    visible={this.state.loadingVisible}
                    message="数据加载中"
                />
            </div>
        )
    }

}

export default ExportCheckReportIndex;